export const PRODUCTS_QUANTITY = {
  IN_STOCK: 50,
  LOW_ON_STOCK: 25,
  OUT_OF_STOCK: 0,
};
